import { Award } from "lucide-react";
import { Section, SectionHeading } from "@/components/common/Section";
import { useReveal } from "@/hooks/useReveal";
import { whyUs } from "@/data/content";

function ValueCard({ title, desc, index }) {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      style={{ transitionDelay: `${(index % 3) * 80}ms` }}
      data-testid={`value-card-${index}`}
      className="reveal border-l-2 border-gold/40 pl-6 py-2 transition-colors duration-300 hover:border-gold"
    >
      <h3 className="font-heading text-xl text-white">{title}</h3>
      <p className="mt-2 text-sm leading-relaxed text-white/65">{desc}</p>
    </div>
  );
}

export function WhyUs() {
  return (
    <Section id="why-us" bg="navy">
      <div className="grid gap-12 lg:grid-cols-3 lg:gap-16">
        <div className="lg:col-span-1">
          <span className="inline-flex items-center gap-2 text-gold-light">
            <Award className="h-5 w-5" />
            <span className="text-xs md:text-sm font-semibold uppercase tracking-[0.2em]">Why Choose Us</span>
          </span>
          <div className="gold-rule my-4" />
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold leading-tight text-white">
            The difference is in the details
          </h2>
          <p className="mt-4 text-white/65 leading-relaxed">
            Businesses across Bengaluru trust BNZ Solutions because we combine premium craftsmanship with dependable, end-to-end delivery.
          </p>
        </div>
        <div className="lg:col-span-2 grid sm:grid-cols-2 gap-x-10 gap-y-10">
          {whyUs.map((w, i) => (
            <ValueCard key={w.title} {...w} index={i} />
          ))}
        </div>
      </div>
    </Section>
  );
}
